module.exports = __webpack_public_path__ + "static/introduction_img3@2x-2730458e1f278b567d1aeaccd44b687c.jpg";